import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { CircularProgress } from '../progress';
import './styles.css';

class Sidebar extends Component {
  static propTypes = {
    type: PropTypes.oneOf(['large', 'small']),
    children: PropTypes.node.isRequired,
    loading: PropTypes.bool,
    animate: PropTypes.bool,
    header: PropTypes.node,
    fullWidth: PropTypes.bool,
  };

  static defaultProps = {
    type: 'small',
    loading: false,
    animate: false,
    header: null,
  };

  render() {
    const { children, type, animate, loading, header, fullWidth } = this.props;

    return (
      <div
        className={`sidebar sidebar-${type}${animate ? ' animate' : ''} ${
          fullWidth ? 'sidebar-full' : ''
        }`}
      >
        {header && (
          <div
            ref={node => {
              this.headerContainer = node;
            }}
          >
            {header}
          </div>
        )}
        <div className="flex-wrapper">
          <div className={`scroll-container ${loading ? 'loading' : ''}`}>
            {loading && <CircularProgress size={24} thickness={3} />}
            {!loading && <div className="scroll-section">{children}</div>}
          </div>
        </div>
      </div>
    );
  }
}

export default Sidebar;
